import { flushSync } from 'react-dom';
import type { NavigationTransitionType } from './navigation';

type ViewTransitionDocument = Document & {
  startViewTransition?: (callback: () => void | Promise<void>) => ViewTransition;
};

export const supportsViewTransitions = () =>
  typeof (document as ViewTransitionDocument).startViewTransition === 'function';

export const runViewTransition = (
  update: () => void,
  type: NavigationTransitionType = 'fade',
) => {
  const start = (document as ViewTransitionDocument).startViewTransition;

  if (!start) {
    update();
    return;
  }

  const root = document.documentElement;
  root.dataset.vtType = type;

  const cleanup = () => {
    delete root.dataset.vtType;
  };

  const runUpdate = () => flushSync(update);

  try {
    const transition = start(runUpdate);
    if (transition?.finished) {
      void transition.finished.then(cleanup).catch(cleanup);
      return;
    }
  } catch {
    // Fall through to a direct DOM update.
  }

  cleanup();
  runUpdate();
};
